import React, { useEffect, useState } from 'react'
import {Form, Button} from 'react-bootstrap';
import enviarContato from './libs/contato'
import image from './img/WhatsAppButtonWhiteMedium.png'
import hamburger from './components/slides/lanches/hamburger-fastfood.png'
function Contato() {
  const [pedido, setPedido ] = useState({ })
  const itens = []
  const [url, setUrl ] = useState('')
  const changeItem = (e)=>{
    const target = e.target
    const name = target.name
    const value = target.value
    if (target.name === 'pedido' && (value !== undefined)) {
      pedido.pedido = value
    }
    if (target.name === 'Qtde' && (value > 0 )) {
      pedido.qtde = value
    }
    if ((pedido.pedido !== undefined) && (pedido.qtde !== undefined)) {
      setPedido({
        pedido: pedido.pedido,
        qtde: pedido.qtde
      })
    }
  }
  const addPedido = (e)=>{
    e.preventDefault()
      itens.push(pedido)
    console.log('itens ', itens);
  }
  const createPedido = async ()=>{
    if (pedido.name && contato.email && contato.telefone && contato.message) {
      const link = await enviarContato(contato)
      await setUrl(link)
    }
  }
  function teste(e){
    e.preventDefault()
    if (contato.name && contato.email && contato.telefone && contato.message) {
      window.open(url, '_blank')
    }
  }
  return (
    <>
    <section className="page-main">
      <header><h1>Contato físico</h1></header>
      <p>Endereço:</p>
      <p>Bairro:</p>
      <p>Cidade:</p>
      <p>Telefone fixo:</p>
      <p>WhatsApp:</p>
    </section>
    </>
  );
}

export default Contato;
